import { useState } from "react";
import Modal , {GameModal} from "./modal";
import { Link } from "react-router-dom";
let pcsSelect = false, clk, pcs_type;
var modalStatus;
var displayWinner;
var toogleGameModal;
const pieces = {
	'King': '♔',
	'Queen': '♕',
	'Rook': '♖',
	'Bishop': '♗',
	'Knight': '♘',
	'Pawn': '♙',
};
function get_pcs(set_type, type) {
	let pcs_type = type;
	if (set_type === "head") {
		return [
			{ pcs: pieces.Rook, typ: pcs_type, isMoved: false },
			{ pcs: pieces.Knight, typ: pcs_type },
			{ pcs: pieces.Bishop, typ: pcs_type },
			{ pcs: pieces.King, typ: pcs_type, isMoved: false },
			{ pcs: pieces.Queen, typ: pcs_type },
			{ pcs: pieces.Bishop, typ: pcs_type },
			{ pcs: pieces.Knight, typ: pcs_type },
			{ pcs: pieces.Rook, typ: pcs_type, isMoved: false }
		];
	} else if (set_type === "pawn") {
		return Array(8).fill({ pcs: pieces.Pawn, typ: pcs_type });
	}

}
// Initialising the board
const initialBoard = [
	get_pcs("head", false),
	get_pcs("pawn", false),
	Array(8).fill({ pcs: '', typ: '' }),
	Array(8).fill({ pcs: '', typ: '' }),
	Array(8).fill({ pcs: '', typ: '' }),
	Array(8).fill({ pcs: '', typ: '' }),
	get_pcs("pawn", true),
	get_pcs("head", true)
];

function color(typ) {
	if (typ === true) {
		return 'black';
	}
	return 'white';
}



class Moves {
	constructor(board) {
		this.position = { x: '', y: '' };
		this.possibleMoves = [];
		this.casselingMoves = [];
		this.attacker = [{
			position: { x: '', y: '' },
			pcs: ''
		}];
		this.piecesLeft = {black: null, white: null};
		// black : [{position, pcs}]
		this.bord = board;
		this.kingPosition = { black: { x: 7, y: 3 }, white: { x: 0, y: 3 } };
		this.indicate_off_delay = 800;
	}
	initializeBoard(){
		this.bord[0] = get_pcs("head",false);
		this.bord[1] = get_pcs("pawn",false);
		this.bord[2].fill({ pcs: '', typ: '' });
		this.bord[3].fill({ pcs: '', typ: '' });
		this.bord[4].fill({ pcs: '', typ: '' });
		this.bord[5].fill({ pcs: '', typ: '' });
		this.bord[6] = get_pcs("pawn",true);
		this.bord[7] = get_pcs("head",true);
		let id = "";
		for(let i = 0; i<8; i++){
			for(let j = 0; j<8; j++){
				id = "x"+j + "_y"+i;
				document.getElementById(id).innerHTML = this.bord[i][j].pcs;
				document.getElementById(id).style.color = color(this.bord[i][j].typ);
			}
		}
		this.initializeTracker();
	};
	setInitPos(posx, posy) {
		this.position = { x: posx, y: posy };
	}
	can_moved(mover, movPos) {
		if (this.bord[movPos.x][movPos.y].pcs === '') {// Possible Moves is empty so you can move there
			return true;
		} else if (this.bord[movPos.x][movPos.y].typ === mover) {// Possible Moves contains own pieces so can't move
			return false;
		} else {// Possible moves isn't empty and doesn't contains own pieces so it can be moved
			return true;
		}
	}
	isJumpAllowed(player, posx) {
		if (player === false && posx === 1) {
			return true;
		} else if (player === true && posx === 6) {
			return true;
		}
	}
	is_empty(pos) {
		if (this.bord[pos.x][pos.y].pcs === '') {
			return true;
		}
		return false;
	}
	isPosExists(pos) {
		if (pos.x > 7 || pos.x < 0) {
			return false;
		} else if (pos.y > 7 || pos.y < 0) {
			return false;
		}
		return true;
	}
	isPromoted(player, posx) {
		if (player === false && posx === 6) {
			return true;
		} else if (player === true && posx === 1) {
			return true;
		}
		return false;
	}
	promote(plyr, pcs, pos) {
		let promote_id = "x" + pos.y + "_y" + pos.x;
		this.bord[pos.x][pos.y] = { pcs: pcs, typ: plyr };
		document.getElementById(promote_id).innerHTML = pcs;
		document.getElementById(promote_id).style.color = color(plyr);
	}
	indicateMoves(status) {
		let mov_id;
		if (status === true) {
			for (let i = 0; i < this.possibleMoves.length; i++) {
				mov_id = "x" + this.possibleMoves[i].y + "_y" + this.possibleMoves[i].x;
				document.getElementById(mov_id).classList.add("possible");
			}
			setTimeout(() => {// Removing the color after delay
				this.indicateMoves(false);
			}, this.indicate_off_delay);
		} else {
			for (let i = 0; i < this.possibleMoves.length; i++) {
				mov_id = "x" + this.possibleMoves[i].y + "_y" + this.possibleMoves[i].x;
				document.getElementById(mov_id).classList.remove("possible");
			}
		}
	}
	isMovExists(mov) {
		var isExists = this.possibleMoves.some((pos) => pos.x === mov.x && pos.y === mov.y);
		return isExists;
	}
	movePcsTo(pos) {
		let dest_id = "x" + pos.y + "_y" + pos.x;
		let src_id = "x" + this.position.y + "_y" + this.position.x;

		// For the promotion of the pawn
		let src_piece = this.bord[this.position.x][this.position.y];
		if (src_piece.pcs === pieces.Pawn && this.isPromoted(src_piece.typ, this.position.x)) {
			modalStatus("");
		}


		// For the casseling moves of a ROOK
		this.bord[pos.x][pos.y] = this.bord[this.position.x][this.position.y];
		if (this.bord[pos.x][pos.y].pcs === pieces.King || this.bord[pos.x][pos.y].pcs === pieces.Rook) {

			// Updating the king new position
			if (this.bord[pos.x][pos.y].typ === true && this.bord[pos.x][pos.y].pcs === pieces.King) {// this is black king pieces
				this.kingPosition.black = { x: pos.x, y: pos.y };
			} else if (this.bord[pos.x][pos.y].pcs === pieces.King) {
				this.kingPosition.white = { x: pos.x, y: pos.y };
			}

			if (this.isCasselingMoves(pos) === true) {
				if (this.position.y > pos.y) {
					this.bord[this.position.x][pos.y + 1] = this.bord[this.position.x][0];
					this.bord[this.position.x][0] = { pcs: '', typ: '' };
					document.getElementById("x" + 0 + "_y" + this.position.x).innerHTML = "";
					document.getElementById("x" + 2 + "_y" + this.position.x).innerHTML = this.bord[this.position.x][pos.y + 1].pcs;
					document.getElementById("x" + 2 + "_y" + this.position.x).style.color = color(this.bord[this.position.x][pos.y + 1].typ);
				} else {
					this.bord[this.position.x][pos.y - 1] = this.bord[this.position.x][7];
					this.bord[this.position.x][7] = { pcs: '', typ: '' };
					document.getElementById("x" + 7 + "_y" + this.position.x).innerHTML = "";
					document.getElementById("x" + 4 + "_y" + this.position.x).innerHTML = this.bord[this.position.x][pos.y - 1].pcs;
					document.getElementById("x" + 4 + "_y" + this.position.x).style.color = color(this.bord[this.position.x][pos.y - 1].typ);
				}
			}
			this.bord[pos.x][pos.y].isMoved = true;
		}

		document.getElementById(dest_id).innerHTML = this.bord[pos.x][pos.y].pcs;
		document.getElementById(src_id).innerHTML = '';
		document.getElementById(dest_id).style.color = color(this.bord[pos.x][pos.y].typ);
		this.bord[this.position.x][this.position.y] = { pcs: '', typ: '' };
		if (this.isKingSafe(!src_piece.typ) === false) {// King is not safe so it may be in checkmate
			if(this.isCheckMate(!src_piece.typ)===true){
				displayWinner(src_piece.typ===true?"Black":"White");
			};
		}
	}
	set_valid_moves(plyr, tempPos) {
		if (this.isPosExists(tempPos) && this.can_moved(plyr, tempPos)) {
			if (this.moveTemp(this.position, tempPos) === true) {
				this.possibleMoves.push(tempPos);
			}
		}
		return 0;
	}
	canCasselLeft(plyr) {
		let cPos = { x: this.position.x, y: 0 };
		if (this.bord[cPos.x][3].typ === this.bord[cPos.x][cPos.y].typ && this.bord[cPos.x][cPos.y].typ !== '') {
			//left side contains rook and both pieces between king and left rook is empty
			if (this.bord[cPos.x][cPos.y].pcs === pieces.Rook && this.bord[cPos.x][1].pcs === '' && this.bord[cPos.x][2].pcs === '') {
				if (this.bord[cPos.x][3].isMoved === false) {// King is not moved yet
					if (this.bord[cPos.x][cPos.y].isMoved === false) {// Rook is not moved
						if (this.isPosSafe(this.position, plyr) === true) {
							return this.isPosSafe({ x: this.position.x, y: 1 }, plyr);
						}
					}
				}
			}
		}
		return false;
	}
	canCasselRight(plyr) {
		let cPos = { x: this.position.x, y: 7 };
		if (this.bord[cPos.x][3].typ === this.bord[cPos.x][7].typ && this.bord[cPos.x][7].typ !== '') {
			//right side contains rook and all pieces between king and right rook is empty
			if (this.bord[cPos.x][cPos.y].pcs === pieces.Rook && this.bord[cPos.x][4].pcs === '' && this.bord[cPos.x][5].pcs === '' && this.bord[cPos.x][6].pcs === '') {
				if (this.bord[cPos.x][3].isMoved === false) {// King is not moved yet
					if (this.bord[cPos.x][cPos.y].isMoved === false) {// Rook is not moved
						if (this.isPosSafe(this.position, plyr) === true) {
							return this.isPosSafe({ x: this.position.x, y: 5 }, plyr);
						}
					}
				}
			}
		}
		return false;
	}
	isCasselingMoves(pos) {
		let len = this.casselingMoves.length;
		for (let i = 0; i < len; i++) {
			if (this.casselingMoves[i].x === pos.x && this.casselingMoves[i].y === pos.y) {
				return true;
			}
		}
		return false;
	}
	moveTemp(fromPos, toPos) {
		let tempBord = JSON.parse(JSON.stringify(this.bord));
		tempBord[toPos.x][toPos.y] = tempBord[fromPos.x][fromPos.y];
		tempBord[fromPos.x][fromPos.y] = { pcs: '', typ: '' };
		let plyr = tempBord[toPos.x][toPos.y].typ;
		let position = plyr === true ? this.kingPosition.black : this.kingPosition.white;
		return this.isPosSafe(position, plyr, tempBord);
	}
	slope(posAttacker, posKing) {
		let slope = (posAttacker.y - posKing.y) / (posAttacker.x - posKing.x);
		let vector = { x: 0, y: 0 };
		if (posAttacker.x > posKing.x) {// Attacker is on your left
			vector.x = 1;
		} else if (posAttacker.x < posKing.x) {// Attacker is on your right
			vector.x = -1;
		} else {// Attacker lies on same vertical line
			vector.x = 0;
		}

		if (posAttacker.y > posKing.y) {// Attacker is at top of king
			vector.y = 1;
		} else if (posAttacker.y < posKing.y) {// Attacker is at bottom of king
			vector.y = -1;
		} else {// Attacker lies on the same horizontal line
			vector.y = 0;
		}

		return { slope: slope, vector: vector };
	}

	canPawnAttack(pos, plyr, board, immediateReturn = true, canDiagonalMove = true) {
		let attackCount = 0;
		// Checking for pawn check
		let dir = -1;
		if (plyr === false) {
			dir = 1;
		}

		// Right Side Pawn Attack
		let temp_pos = { x: pos.x + dir, y: pos.y + 1 };
		if (this.isPosExists(temp_pos)) {
			if (board[temp_pos.x][temp_pos.y].pcs === pieces.Pawn && board[temp_pos.x][temp_pos.y].typ !== plyr) {
				if (immediateReturn === true) {
					return true;
				}
				this.attacker.push({ position: temp_pos, pcs: pieces.Pawn });
				attackCount++;
			}
		}

		// Left side pawn attack
		temp_pos = { x: pos.x + dir, y: pos.y - 1 };
		if (this.isPosExists(temp_pos)) {
			if (board[temp_pos.x][temp_pos.y].pcs === pieces.Pawn && board[temp_pos.x][temp_pos.y].typ !== plyr) {
				if (immediateReturn === true) {
					return true;
				}
				this.attacker.push({ position: temp_pos, pcs: pieces.Pawn });
				attackCount++;
			}
		}

		return immediateReturn === true ? false : attackCount !== 0;
	}
	canKnightAttack(pos, plyr, board, immediateReturn = true) {
		const moves = [
			{ x: pos.x + 2, y: pos.y + 1 },
			{ x: pos.x + 2, y: pos.y - 1 },
			{ x: pos.x - 2, y: pos.y + 1 },
			{ x: pos.x - 2, y: pos.y - 1 },
			{ x: pos.x + 1, y: pos.y + 2 },
			{ x: pos.x + 1, y: pos.y - 2 },
			{ x: pos.x - 1, y: pos.y + 2 },
			{ x: pos.x - 1, y: pos.y - 2 }
		];
		let tempBox;
		let attackCount = 0;
		for (let i = 0; i < 8; i++) {
			if (this.isPosExists(moves[i]) === true) {
				tempBox = board[moves[i].x][moves[i].y];
				if (tempBox.pcs === pieces.Knight && tempBox.typ !== plyr) {
					if (immediateReturn === true) {
						return true;
					}
					this.attacker.push({ position: moves[i], pcs: tempBox.pcs });
					attackCount++;
				}
			}
		}

		return immediateReturn === true ? false : attackCount !== 0;
	}
	canStraightAttack(pos, plyr, board, immediateReturn = true, canKingMove = true) {
		// Immediate return returns the value when at least one piece can attack when it is set true
		// canKingMove will don't allow king to attack
		let temp;
		let tempBox;
		let attackCount = 0;
		// from current position to the top
		for (let i = 1; i < (8 - pos.y); i++) {
			temp = { x: pos.x, y: pos.y + i };
			if (temp.x === this.position.x && temp.y === this.position.y) {
				continue;
			}
			if (this.isPosExists(temp) === true) {
				tempBox = board[temp.x][temp.y];
				if (i === 1 && tempBox.pcs === pieces.King && tempBox.typ !== plyr && canKingMove===true) {
					if (immediateReturn === true) {
						return true;
					} else {
						this.attacker.push({ position: temp, pcs: tempBox.pcs });
						attackCount++;
					}
				} else if ((tempBox.pcs === pieces.Rook || tempBox.pcs === pieces.Queen) && tempBox.typ !== plyr) {
					if (immediateReturn === true) {
						return true;
					} else {
						this.attacker.push({ position: temp, pcs: tempBox.pcs });
						attackCount++;
					}
				} else if (tempBox.pcs !== '') {
					break;
				}
			}
		}
		// From current position to the bottom
		for (let i = 1; i <= pos.y; i++) {
			temp = { x: pos.x, y: pos.y - i };
			if (temp.x === this.position.x && temp.y === this.position.y) {
				continue;
			}
			if (this.isPosExists(temp)) {
				tempBox = board[temp.x][temp.y];
				if (i === 1 && tempBox.pcs === pieces.King && tempBox.typ !== plyr && canKingMove===true) {
					if (immediateReturn === true) {
						return true;
					} else {
						this.attacker.push({ position: temp, pcs: tempBox.pcs });
						attackCount++;
					}
				} else if ((tempBox.pcs === pieces.Rook || tempBox.pcs === pieces.Queen) && tempBox.typ !== plyr) {
					if (immediateReturn === true) {
						return true;
					} else {
						this.attacker.push({ position: temp, pcs: tempBox.pcs });
						attackCount++;
					}
				} else if (tempBox.pcs !== '') {
					break;
				}
			}
		}
		// From current position to the right side 
		for (let i = 1; i <= pos.x; i++) {
			temp = { x: pos.x - i, y: pos.y };
			if (temp.x === this.position.x && temp.y === this.position.y) {
				continue;
			}
			if (this.isPosExists(temp)) {
				tempBox = board[temp.x][temp.y];
				if (i === 1 && tempBox.pcs === pieces.King && tempBox.typ !== plyr && canKingMove===true) {
					if (immediateReturn === true) {
						return true;
					} else {
						this.attacker.push({ position: temp, pcs: tempBox.pcs });
						attackCount++;
					}
				} else if ((tempBox.pcs === pieces.Rook || tempBox.pcs === pieces.Queen) && tempBox.typ !== plyr) {
					if (immediateReturn === true) {
						return true;
					} else {
						this.attacker.push({ position: temp, pcs: tempBox.pcs });
						attackCount++;
					}
				} else if (tempBox.pcs !== '') {
					break;
				}
			}
		}
		// From current position to the left side
		for (let i = 1; i < (8 - pos.x); i++) {
			temp = { x: pos.x + i, y: pos.y };
			if (temp.x === this.position.x && temp.y === this.position.y) {
				continue;
			}
			if (this.isPosExists(temp)) {
				tempBox = board[temp.x][temp.y];
				if (i === 1 && tempBox.pcs === pieces.King && tempBox.typ !== plyr && canKingMove===true) {
					if (immediateReturn === true) {
						return true;
					} else {
						this.attacker.push({ position: temp, pcs: tempBox.pcs });
						attackCount++;
					}
				} else if ((tempBox.pcs === pieces.Rook || tempBox.pcs === pieces.Queen) && tempBox.typ !== plyr) {
					if (immediateReturn === true) {
						return true;
					} else {
						this.attacker.push({ position: temp, pcs: tempBox.pcs });
						attackCount++;
					}
				} else if (tempBox.pcs !== "") {
					break;
				}
			}
		}
		return immediateReturn === true ? false : attackCount !== 0;
	}
	canDiagonalAttack(pos, plyr, board, immediateReturn = true, canKingMove = true) {
		let temp_position = { x: '', y: '' };
		let tempBox;
		let attackCount = 0;

		for (let i = 1; i < (8 - pos.x); i++) {// for the top left diagonal
			temp_position = { x: pos.x + i, y: pos.y + i };
			if (temp_position.x === this.position.x && temp_position.y === this.position.y) {
				continue;
			}
			if (this.isPosExists(temp_position)) {
				tempBox = board[temp_position.x][temp_position.y];
				if (i === 1 && tempBox.pcs === pieces.King && tempBox.typ !== plyr && canKingMove===true) {
					if (immediateReturn === true) {
						return true;
					} else {
						this.attacker.push({ position: temp_position, pcs: tempBox.pcs });
						attackCount++;
					}
				} else if ((tempBox.pcs === pieces.Bishop || tempBox.pcs === pieces.Queen) && tempBox.typ !== plyr) {
					if (immediateReturn === true) {
						return true;
					} else {
						this.attacker.push({ position: temp_position, pcs: tempBox.pcs });
						attackCount++;
					}
				} else if (tempBox.pcs !== "") {
					break;
				};
			}
		}
		for (let i = 1; i <= pos.x; i++) {// For the top right diagonal
			temp_position = { x: pos.x - i, y: pos.y + i };
			if (temp_position.x === this.position.x && temp_position.y === this.position.y) {
				continue;
			}
			if (this.isPosExists(temp_position)) {
				tempBox = board[temp_position.x][temp_position.y];
				if (i === 1 && tempBox.pcs === pieces.King && tempBox.typ !== plyr && canKingMove===true) {
					if (immediateReturn === true) {
						return true;
					} else {
						this.attacker.push({ position: temp_position, pcs: tempBox.pcs });
						attackCount++;
					}
				} else if ((tempBox.pcs === pieces.Bishop || tempBox.pcs === pieces.Queen) && tempBox.typ !== plyr) {
					if (immediateReturn === true) {
						return true;
					} else {
						this.attacker.push({ position: temp_position, pcs: tempBox.pcs });
						attackCount++;
					}
				} else if (tempBox.pcs !== "") {
					break;
				}
			}
		}
		for (let i = 1; i <= pos.x; i++) {// for the bottom right diagonal //
			temp_position = { x: pos.x - i, y: pos.y - i };
			if (temp_position.x === this.position.x && temp_position.y === this.position.y) {
				continue;
			}
			if (this.isPosExists(temp_position)) {
				tempBox = board[temp_position.x][temp_position.y];
				if (i === 1 && tempBox.pcs === pieces.King && tempBox.typ !== plyr && canKingMove===true) {
					if (immediateReturn === true) {
						return true;
					} else {
						this.attacker.push({ position: temp_position, pcs: tempBox.pcs });
						attackCount++;
					}
				} else if ((tempBox.pcs === pieces.Bishop || tempBox.pcs === pieces.Queen) && tempBox.typ !== plyr) {
					if (immediateReturn === true) {
						return true;
					} else {
						this.attacker.push({ position: temp_position, pcs: tempBox.pcs });
						attackCount++;
					}
				} else if (tempBox.pcs !== "") {
					break;
				}
			}
		}
		for (let i = 1; i < (8 - pos.x); i++) {// for the bottom left diagonal //
			temp_position = { x: pos.x + i, y: pos.y - i };
			if (temp_position.x === this.position.x && temp_position.y === this.position.y) {
				continue;
			}
			if (this.isPosExists(temp_position)) {
				tempBox = board[temp_position.x][temp_position.y];
				if (i === 1 && tempBox.pcs === pieces.King && tempBox.typ !== plyr && canKingMove===true) {
					if (immediateReturn === true) {
						return true;
					} else {
						this.attacker.push({ position: temp_position, pcs: tempBox.pcs });
						attackCount++;
					}
				} else if ((tempBox.pcs === pieces.Bishop || tempBox.pcs === pieces.Queen) && tempBox.typ !== plyr) {
					if (immediateReturn === true) {
						return true;
					} else {
						this.attacker.push({ position: temp_position, pcs: tempBox.pcs });
						attackCount++;
					}
				} else if (tempBox.pcs !== "") {
					break;
				}
			}
		}
		return immediateReturn === true ? false : attackCount !== 0;
	}
	canPawnBlock(pos, plyr){
		let dir = plyr===false?-1:1;
		let tempPos = {x: '', y: pos.y};
		let currPieces;
		// For straight move block
		if(pos.y!==this.attacker[0].position.y){
			for(let i = 1; i<=2; i++){
				tempPos.x = pos.x + dir*i;
				if(this.isPosExists(tempPos)===true){
					currPieces = this.bord[tempPos.x][tempPos.y];
					if(plyr===currPieces.typ && currPieces.pcs===pieces.Pawn){
						return true;
					}
				}
			}
		}

		tempPos = {x: this.attacker[0].position.x + dir, y: this.attacker[0].position.y+1};
		if(this.isPosExists(tempPos)===true){
			currPieces = this.bord[tempPos.x][tempPos.y];
			if(plyr===currPieces.typ && currPieces.pcs===pieces.Pawn){
				return true;
			}
		}
		tempPos = {x: this.attacker[0].position.x + dir, y: this.attacker[0].position.y-1};
		if(this.isPosExists(tempPos)===true){
			currPieces = this.bord[tempPos.x][tempPos.y];
			if(plyr===currPieces.typ && currPieces.pcs===pieces.Pawn){
				return true;
			}
		}
		return false;
	}
	isPosSafe(pos, plyr, board = this.bord) {// Determines whether position is safe for current player king
		if (this.canPawnAttack(pos, plyr, board) === true) {
			return false;
		}

		if (this.canKnightAttack(pos, plyr, board) === true) {
			return false;
		}

		if (this.canStraightAttack(pos, plyr, board) === true) {
			return false;
		}

		if (this.canDiagonalAttack(pos, plyr, board) === true) {
			return false;
		}
		return true;
	}
	isKingSafe(plyr) {
		let position = plyr === true ? this.kingPosition.black : this.kingPosition.white;
		//Finding all the attackers
		this.attacker = [];
		this.canPawnAttack(position, plyr, this.bord, false);
		this.canKnightAttack(position, plyr, this.bord, false);
		this.canStraightAttack(position, plyr, this.bord, false);
		this.canDiagonalAttack(position, plyr, this.bord, false);

		if (this.isPosSafe(position, plyr) !== true) {
			document.getElementById("x" + position.y + "_y" + position.x).classList.add("checked");
			setTimeout(() => {
				document.getElementById("x" + position.y + "_y" + position.x).classList.remove("checked");
			}, this.indicate_off_delay);
			return false;
		}
		return true;
	}
	isKingMovesLeft(plyr) {
		this.possibleMoves = [];
		let tempPos = plyr === false ? this.kingPosition.white : this.kingPosition.black;
		this.position = tempPos;
		this.kingPossibleMoves(plyr);
		return this.possibleMoves.length !== 0;
	}
	canBlockCheck(plyr) {//Checks whether any pieces can block plyr check
		let kingPosition = plyr === false ? this.kingPosition.white : this.kingPosition.black;
		let m = this.slope(this.attacker[0].position, kingPosition);
		let i = 2;// first value is pre incremented in tempPos declaration so starting from 2
		let attackerPos = this.attacker[0].position;
		let tempPos = { x: kingPosition.x + m.vector.x, y: kingPosition.y + m.vector.y };
		// Move from king's position + 1 to attacker position
		// console.log(plyr);
		while (this.reachingAttacker(tempPos,attackerPos,kingPosition,m)===true) {
			let straightBlock = this.canStraightAttack(tempPos,!plyr,this.bord,true,false);
			let diagonalBlock = this.canDiagonalAttack(tempPos, !plyr,this.bord,true,false);
			let knightBlock = this.canKnightAttack(tempPos, !plyr,this.bord, true);
			let pawnBlock = this.canPawnBlock(tempPos,plyr);

			if((pawnBlock ===true || knightBlock ===true) || (diagonalBlock ===true || straightBlock===true)){
				return true;
			}
			tempPos = { x: kingPosition.x + i * m.vector.x, y: kingPosition.y + i * m.vector.y };
			i++;
		}
		return false;
	}
	reachingAttacker(currentPos, attackerPos, kingPosition, dir){
		if(dir.slope===0){// Attacker is on the x axis
			if(attackerPos.x<kingPosition.x){// attacker is in the right
				return currentPos.x>=attackerPos.x;
			}else{// Attacker is in the left
				return currentPos.x<=attackerPos.x;
			}
		}else if(dir.slope===-Infinity){// Attacker is on the y axis
			if(attackerPos.y<kingPosition.y){// attacker is at buttom
				return currentPos.y>=attackerPos.y;
			}
		}else if(dir.slope===Infinity){// Attacker is on the y axis
			if(attackerPos.y>kingPosition.y){// Attacker is at top 
				return currentPos.y<=attackerPos.y;
			}
		}else if(dir.slope===1){// second and fourth quadrant diagonal
			if(attackerPos.y>kingPosition.y){//Attacker is at Top left diagonal
				return currentPos.x<=attackerPos.x;
			}else{// Attacker is at Bottom Right diagonal
				return currentPos.x>=attackerPos.x;
			}
		}else if(dir.slope===-1){// First and Third quadrant diagonal
			if(attackerPos.y>kingPosition.y){// Attacker is at top right corner
				return currentPos.y<=attackerPos.y;
			}else{// Attacker is at bottom left diagonal
				return currentPos.y>=attackerPos.y;
			}
		}
		return false;
	}
	isCheckMate(plyr) {
		// console.log(this.canBlockCheck(plyr));
		if(this.isKingMovesLeft(plyr)===true){// some moves left
			return false;
		}else{// king moves not left
			if(this.attacker.length>=2){// more than one attackers at a time can lead to checkmate
				return true;
			}else{// Try blocking the check mate
				let canBlock = this.canBlockCheck(plyr);
				if(canBlock===true){// You can block check mate so you are not in checkmate
					return false;
				}else{// You can't block checkmate
					return true;
				}
			}
		}
	}

	// Function for initializing the moves
	initializeTracker(){
		this.piecesLeft.black = [
			{x: 7, y: 0},   {x: 7, y: 1},
			{x: 7, y: 2},   {x: 7, y: 3},
			{x: 7, y: 4},   {x: 7, y: 5},
			{x: 7, y: 6},	{x: 7, y: 7},
			{x: 6, y: 0},   {x: 6, y: 1},
			{x: 6, y: 2},	{x: 6, y: 3},
			{x: 6, y: 4},	{x: 6, y: 5},
			{x: 6, y: 6},	{x: 6, y: 7}];
			this.piecesLeft.white = [
			{x: 0, y: 0},	{x: 0, y: 1},	
			{x: 0, y: 2},	{x: 0, y: 3},
			{x: 0, y: 4},	{x: 0, y: 5},
			{x: 0, y: 6},	{x: 0, y: 7},
			{x: 1, y: 0},	{x: 1, y: 1},
			{x: 1, y: 2},	{x: 1, y: 3},
			{x: 1, y: 4},	{x: 1, y: 5},
			{x: 1, y: 6},	{x: 1, y: 7}];
	}

	pawnPossibleMoves(plyr) {
		let dir = plyr === false ? 1 : -1;
		this.promoted = plyr;
		var temp = {
			front: { x: this.position.x + dir * 1, y: this.position.y },
			jump: { x: this.position.x + dir * 2, y: this.position.y },
			right: { x: this.position.x + dir * 1, y: this.position.y + dir * 1 },
			left: { x: this.position.x + dir * 1, y: this.position.y - dir * 1 }
		}
		// 1 step  & 2 step forward moves //
		if (this.isPosExists(temp.front) === true) {
			if (this.is_empty(temp.front) && this.can_moved(plyr, temp.front)) {
				if (this.moveTemp(this.position, temp.front) === true) {
					this.possibleMoves.push(temp.front);
				}

				// 2 setp forward moves can't jump if it contains an element//
				let firstStepEmpty = this.is_empty(temp.front);
				if (this.isPosExists(temp.jump)) {
					if (this.is_empty(temp.jump) && this.isJumpAllowed(plyr, this.position.x) && firstStepEmpty && this.can_moved(plyr, temp.jump)) {
						if (this.moveTemp(this.position, temp.jump) === true) {
							this.possibleMoves.push(temp.jump);
						}
					}
				}

			}
		}

		// Right Diagonal Moves //
		if (this.isPosExists(temp.right) === true) {
			if (this.can_moved(plyr, temp.right) && !this.is_empty(temp.right)) {
				if (this.moveTemp(this.position, temp.right) === true) {
					this.possibleMoves.push(temp.right);
				}
			}
		}

		// left Diagonal Moves//
		if (this.isPosExists(temp.left) === true) {
			if (this.can_moved(plyr, temp.left) && !this.is_empty(temp.left)) {
				if (this.moveTemp(this.position, temp.left) === true) {
					this.possibleMoves.push(temp.left);
				}
			}
		}
	}
	rookPossibleMoves(plyr) {
		let temp;

		// from current position to the top
		for (let i = 1; i < (8 - this.position.y); i++) {
			temp = { x: this.position.x, y: this.position.y + i };
			this.set_valid_moves(plyr, temp);
			if (!this.is_empty(temp)) {
				break;
			}
		}
		// From current position to the bottom
		for (let i = 1; i <= this.position.y; i++) {
			temp = { x: this.position.x, y: this.position.y - i };
			this.set_valid_moves(plyr, temp);
			if (!this.is_empty(temp)) {
				break;
			}
		}
		// From current position to the right side 
		for (let i = 1; i <= this.position.x; i++) {
			temp = { x: this.position.x - i, y: this.position.y };
			this.set_valid_moves(plyr, temp);
			if (!this.is_empty(temp)) {
				break;
			}
		}
		// From current position to the left side
		for (let i = 1; i < (8 - this.position.x); i++) {
			temp = { x: this.position.x + i, y: this.position.y };
			this.set_valid_moves(plyr, temp);
			if (!this.is_empty(temp)) {
				break;
			}
		}
	}
	knightPossibleMoves(plyr) {
		const moves = [
			{ x: this.position.x + 2, y: this.position.y + 1 },
			{ x: this.position.x + 2, y: this.position.y - 1 },
			{ x: this.position.x - 2, y: this.position.y + 1 },
			{ x: this.position.x - 2, y: this.position.y - 1 },
			{ x: this.position.x + 1, y: this.position.y + 2 },
			{ x: this.position.x + 1, y: this.position.y - 2 },
			{ x: this.position.x - 1, y: this.position.y + 2 },
			{ x: this.position.x - 1, y: this.position.y - 2 }
		];
		for (let i = 0; i < 8; i++) {
			this.set_valid_moves(plyr, moves[i]);
		}
	}
	bishopPossibleMoves(plyr) {
		let temp_position = { x: '', y: '' };


		for (let i = 1; i < (8 - this.position.x); i++) {// for the top left diagonal
			temp_position = { x: this.position.x + i, y: this.position.y + i };
			if (this.isPosExists(temp_position)) {
				this.set_valid_moves(plyr, temp_position);
				if (!this.is_empty(temp_position)) {
					break;
				}
			}
		}
		for (let i = 1; i <= this.position.x; i++) {// For the top right diagonal
			temp_position = { x: this.position.x - i, y: this.position.y + i };
			if (this.isPosExists(temp_position)) {
				this.set_valid_moves(plyr, temp_position);
				if (!this.is_empty(temp_position)) {
					break;
				}
			}
		}
		for (let i = 1; i <= this.position.x; i++) {// for the bottom right diagonal //
			temp_position = { x: this.position.x - i, y: this.position.y - i };
			if (this.isPosExists(temp_position)) {
				this.set_valid_moves(plyr, temp_position);
				if (!this.is_empty(temp_position)) {
					break;
				}
			}
		}
		for (let i = 1; i < (8 - this.position.x); i++) {// for the bottom left diagonal //
			temp_position = { x: this.position.x + i, y: this.position.y - i };
			if (this.isPosExists(temp_position)) {
				this.set_valid_moves(plyr, temp_position);
				if (!this.is_empty(temp_position)) {
					break;
				}
			}
		}
	}
	queenPossibleMoves(plyr) {
		this.bishopPossibleMoves(plyr);
		this.rookPossibleMoves(plyr);
	}
	kingPossibleMoves(plyr) {
		this.isPosSafe(this.position, plyr);
		if (this.canCasselLeft(plyr) === true) {
			this.possibleMoves.push({ x: this.position.x, y: this.position.y - 2 });
			this.casselingMoves.push({ x: this.position.x, y: this.position.y - 2 });
		}
		if (this.canCasselRight(plyr) === true) {
			this.possibleMoves.push({ x: this.position.x, y: this.position.y + 2 });
			this.casselingMoves.push({ x: this.position.x, y: this.position.y + 2 });
		}

		// Calculation of king possible moves//
		let coordinate = [{ x: -1, y: 1 }, { x: -1, y: 0 }, { x: -1, y: -1 }, { x: 0, y: -1 }, { x: 1, y: -1 }, { x: 1, y: 0 }, { x: 1, y: 1 }, { x: 0, y: 1 }];
		let tempPos;
		for (let i = 0; i < 8; i++) {
			tempPos = { x: this.position.x + coordinate[i].x, y: this.position.y + coordinate[i].y };
			if (this.isPosExists(tempPos) === true) {
				if (this.can_moved(plyr, tempPos) === true) {
					if (this.isPosSafe(tempPos, plyr) === true) {
						this.possibleMoves.push(tempPos);
					}
				}
			}
		}
	}
}


function Board() {
	var mov = new Moves(initialBoard);
	var bord = mov.bord;
	mov.initializeTracker();

	// Functions and variables for handeling modal of promotion
	const [modalState, setModalState] = useState("none");// For display promotion cards
	const [gameModal, setGameModal] = useState("none");// for displaying winner and looser
	const [winner, setWinner] = useState(null);
	modalStatus = (state) => {
		setModalState(state);
	};
	displayWinner = (winner)=>{
		setWinner(winner);
		setGameModal("");
	}
	toogleGameModal = ()=>{
		if(gameModal==="none"){
			setGameModal("");
		}else{
			setGameModal("none");
			mov.initializeBoard();
		}
	}
	const promoteTo = (e) => {
		mov.promote(pcs_type, e.target.innerHTML, { x: clk.x, y: clk.y });
		setModalState("none");
	}

	// Main Logic Starts here
	function identify_pieces(position) {
		var inside_box = mov.bord[position.x][position.y];

		if (pcsSelect === true) {
			let clk_position = { x: position.x, y: position.y };
			if (mov.isMovExists(clk_position) === true) {
				mov.movePcsTo(clk_position);
				pcsSelect = false;
			} else {// clear possible Moves if it is clk on other box
				mov.possibleMoves = [];
				pcsSelect = false;
			}
		} else {
			if (inside_box.pcs === pieces.Pawn) {
				pcsSelect = true;
				pawn(position, inside_box.typ);
			} else if (inside_box.pcs === pieces.Rook) {
				pcsSelect = true;
				rook(position, inside_box.typ);
			} else if (inside_box.pcs === pieces.Knight) {
				pcsSelect = true;
				knight(position, inside_box.typ);
			} else if (inside_box.pcs === pieces.Bishop) {
				pcsSelect = true;
				bishop(position, inside_box.typ);
			} else if (inside_box.pcs === pieces.Queen) {
				pcsSelect = true;
				queen(position, inside_box.typ);
			} else if (inside_box.pcs === pieces.King) {
				pcsSelect = true;
				king(position, inside_box.typ);
			}

			pcs_type = inside_box.typ;
		}

	}

	// Pawn moves
	function pawn(position, player) {
		mov.setInitPos(position.x, position.y);
		mov.possibleMoves = [];
		mov.pawnPossibleMoves(player);
		mov.indicateMoves(true);
	}
	// For Rook Moves
	function rook(position, player) {
		mov.setInitPos(position.x, position.y);
		mov.possibleMoves = [];
		mov.rookPossibleMoves(player);
		mov.indicateMoves(true);
	}
	// For Knight Moves
	function knight(position, player) {
		mov.setInitPos(position.x, position.y);
		mov.possibleMoves = [];
		mov.knightPossibleMoves(player);
		mov.indicateMoves(true);
	}
	// For bishop moves //
	function bishop(position, player) {
		mov.setInitPos(position.x, position.y);
		mov.possibleMoves = [];
		mov.bishopPossibleMoves(player);
		mov.indicateMoves(true);
	}
	// for queen movement //
	function queen(position, player) {
		mov.setInitPos(position.x, position.y);
		mov.possibleMoves = [];
		mov.queenPossibleMoves(player);
		mov.indicateMoves(true);
	}
	// for king movement //
	function king(position, player) {
		mov.setInitPos(position.x, position.y);
		mov.possibleMoves = [];
		mov.kingPossibleMoves(player);
		mov.indicateMoves(true);
	}
	// Handeling the click events //
	const boxEvent = (e) => {
		var selected = e.target;
		if (selected.classList.contains('box')) {
			clk = {
				id: selected.id,
				x: parseInt(selected.id.charAt(4)),
				y: parseInt(selected.id.charAt(1))// x and y are interchanged //
			}
			identify_pieces(clk);
		}
	}




	return (
		<>
			<Modal status={modalState} pieces={pieces} promoteTo={promoteTo} />
			<GameModal status={gameModal} winner={winner} gameModalToogle={toogleGameModal}/>
			<div className="d-flex justify-content-center align-items-center row">
				<div className="container control_board d-flex justify-content-center align-items-center">
					<Link to="/chess-game/" className="btn btn-dark control_btn" title="Home">
						<img src="./images/home.svg" alt="House logo" />
					</Link>
					<button className="btn btn-dark control_btn" title="Idea">
						<img src="./images/idea.svg" alt="idea logo" />
					</button>
					<button className="btn btn-dark control_btn" title="Undo">
						<img src="./images/undo.svg" alt="undo logo" />
					</button>
					<button className="btn btn-dark control_btn" title="Redo">
						<img src="./images/redo.svg" alt="redo logo" />
					</button>
					<button className="btn btn-dark control_btn" title="Settings">
						<img src="./images/settings.svg" alt="settings logo" />
					</button>
				</div>
				<div className="chessboard container-sm mb-3" onClick={boxEvent}>
					<div className="box_row">
						<div className="black box" style={{ color: color(bord[7][0].typ) }} id="x0_y7">{bord[7][0].pcs}</div>
						<div className="white box" style={{ color: color(bord[7][1].typ) }} id="x1_y7">{bord[7][1].pcs}</div>
						<div className="black box" style={{ color: color(bord[7][2].typ) }} id="x2_y7">{bord[7][2].pcs}</div>
						<div className="white box" style={{ color: color(bord[7][3].typ) }} id="x3_y7">{bord[7][3].pcs}</div>
						<div className="black box" style={{ color: color(bord[7][4].typ) }} id="x4_y7">{bord[7][4].pcs}</div>
						<div className="white box" style={{ color: color(bord[7][5].typ) }} id="x5_y7">{bord[7][5].pcs}</div>
						<div className="black box" style={{ color: color(bord[7][6].typ) }} id="x6_y7">{bord[7][6].pcs}</div>
						<div className="white box" style={{ color: color(bord[7][7].typ) }} id="x7_y7">{bord[7][7].pcs}</div>
					</div>
					<div className="box_row">
						<div className="white box" style={{ color: color(bord[6][0].typ) }} id="x0_y6">{bord[6][0].pcs}</div>
						<div className="black box" style={{ color: color(bord[6][1].typ) }} id="x1_y6">{bord[6][1].pcs}</div>
						<div className="white box" style={{ color: color(bord[6][2].typ) }} id="x2_y6">{bord[6][2].pcs}</div>
						<div className="black box" style={{ color: color(bord[6][3].typ) }} id="x3_y6">{bord[6][3].pcs}</div>
						<div className="white box" style={{ color: color(bord[6][4].typ) }} id="x4_y6">{bord[6][4].pcs}</div>
						<div className="black box" style={{ color: color(bord[6][5].typ) }} id="x5_y6">{bord[6][5].pcs}</div>
						<div className="white box" style={{ color: color(bord[6][6].typ) }} id="x6_y6">{bord[6][6].pcs}</div>
						<div className="black box" style={{ color: color(bord[6][7].typ) }} id="x7_y6">{bord[6][7].pcs}</div>
					</div>
					<div className="box_row">
						<div className="black box" style={{ color: color(bord[5][0].typ) }} id="x0_y5">{bord[5][0].pcs}</div>
						<div className="white box" style={{ color: color(bord[5][1].typ) }} id="x1_y5">{bord[5][1].pcs}</div>
						<div className="black box" style={{ color: color(bord[5][2].typ) }} id="x2_y5">{bord[5][2].pcs}</div>
						<div className="white box" style={{ color: color(bord[5][3].typ) }} id="x3_y5">{bord[5][3].pcs}</div>
						<div className="black box" style={{ color: color(bord[5][4].typ) }} id="x4_y5">{bord[5][4].pcs}</div>
						<div className="white box" style={{ color: color(bord[5][5].typ) }} id="x5_y5">{bord[5][5].pcs}</div>
						<div className="black box" style={{ color: color(bord[5][6].typ) }} id="x6_y5">{bord[5][6].pcs}</div>
						<div className="white box" style={{ color: color(bord[5][7].typ) }} id="x7_y5">{bord[5][7].pcs}</div>
					</div>
					<div className="box_row">
						<div className="white box" style={{ color: color(bord[4][0].typ) }} id="x0_y4">{bord[4][0].pcs}</div>
						<div className="black box" style={{ color: color(bord[4][1].typ) }} id="x1_y4">{bord[4][1].pcs}</div>
						<div className="white box" style={{ color: color(bord[4][2].typ) }} id="x2_y4">{bord[4][2].pcs}</div>
						<div className="black box" style={{ color: color(bord[4][3].typ) }} id="x3_y4">{bord[4][3].pcs}</div>
						<div className="white box" style={{ color: color(bord[4][4].typ) }} id="x4_y4">{bord[4][4].pcs}</div>
						<div className="black box" style={{ color: color(bord[4][5].typ) }} id="x5_y4">{bord[4][5].pcs}</div>
						<div className="white box" style={{ color: color(bord[4][6].typ) }} id="x6_y4">{bord[4][6].pcs}</div>
						<div className="black box" style={{ color: color(bord[4][7].typ) }} id="x7_y4">{bord[4][7].pcs}</div>
					</div>
					<div className="box_row">
						<div className="black box" style={{ color: color(bord[3][0].typ) }} id="x0_y3">{bord[3][0].pcs}</div>
						<div className="white box" style={{ color: color(bord[3][1].typ) }} id="x1_y3">{bord[3][1].pcs}</div>
						<div className="black box" style={{ color: color(bord[3][2].typ) }} id="x2_y3">{bord[3][2].pcs}</div>
						<div className="white box" style={{ color: color(bord[3][3].typ) }} id="x3_y3">{bord[3][3].pcs}</div>
						<div className="black box" style={{ color: color(bord[3][4].typ) }} id="x4_y3">{bord[3][4].pcs}</div>
						<div className="white box" style={{ color: color(bord[3][5].typ) }} id="x5_y3">{bord[3][5].pcs}</div>
						<div className="black box" style={{ color: color(bord[3][6].typ) }} id="x6_y3">{bord[3][6].pcs}</div>
						<div className="white box" style={{ color: color(bord[3][7].typ) }} id="x7_y3">{bord[3][7].pcs}</div>
					</div>
					<div className="box_row">
						<div className="white box" style={{ color: color(bord[2][0].typ) }} id="x0_y2">{bord[2][0].pcs}</div>
						<div className="black box" style={{ color: color(bord[2][1].typ) }} id="x1_y2">{bord[2][1].pcs}</div>
						<div className="white box" style={{ color: color(bord[2][2].typ) }} id="x2_y2">{bord[2][2].pcs}</div>
						<div className="black box" style={{ color: color(bord[2][3].typ) }} id="x3_y2">{bord[2][3].pcs}</div>
						<div className="white box" style={{ color: color(bord[2][4].typ) }} id="x4_y2">{bord[2][4].pcs}</div>
						<div className="black box" style={{ color: color(bord[2][5].typ) }} id="x5_y2">{bord[2][5].pcs}</div>
						<div className="white box" style={{ color: color(bord[2][6].typ) }} id="x6_y2">{bord[2][6].pcs}</div>
						<div className="black box" style={{ color: color(bord[2][7].typ) }} id="x7_y2">{bord[2][7].pcs}</div>
					</div>
					<div className="box_row">
						<div className="black box" style={{ color: color(bord[1][0].typ) }} id="x0_y1">{bord[1][0].pcs}</div>
						<div className="white box" style={{ color: color(bord[1][1].typ) }} id="x1_y1">{bord[1][1].pcs}</div>
						<div className="black box" style={{ color: color(bord[1][2].typ) }} id="x2_y1">{bord[1][2].pcs}</div>
						<div className="white box" style={{ color: color(bord[1][3].typ) }} id="x3_y1">{bord[1][3].pcs}</div>
						<div className="black box" style={{ color: color(bord[1][4].typ) }} id="x4_y1">{bord[1][4].pcs}</div>
						<div className="white box" style={{ color: color(bord[1][5].typ) }} id="x5_y1">{bord[1][5].pcs}</div>
						<div className="black box" style={{ color: color(bord[1][6].typ) }} id="x6_y1">{bord[1][6].pcs}</div>
						<div className="white box" style={{ color: color(bord[1][7].typ) }} id="x7_y1">{bord[1][7].pcs}</div>
					</div>
					<div className="box_row">
						<div className="white box" style={{ color: color(bord[0][0].typ) }} id="x0_y0">{bord[0][0].pcs}</div>
						<div className="black box" style={{ color: color(bord[0][1].typ) }} id="x1_y0">{bord[0][1].pcs}</div>
						<div className="white box" style={{ color: color(bord[0][2].typ) }} id="x2_y0">{bord[0][2].pcs}</div>
						<div className="black box" style={{ color: color(bord[0][3].typ) }} id="x3_y0">{bord[0][3].pcs}</div>
						<div className="white box" style={{ color: color(bord[0][4].typ) }} id="x4_y0">{bord[0][4].pcs}</div>
						<div className="black box" style={{ color: color(bord[0][5].typ) }} id="x5_y0">{bord[0][5].pcs}</div>
						<div className="white box" style={{ color: color(bord[0][6].typ) }} id="x6_y0">{bord[0][6].pcs}</div>
						<div className="black box" style={{ color: color(bord[0][7].typ) }} id="x7_y0">{bord[0][7].pcs}</div>
					</div>
				</div>
			</div>
		</>
	);
}
export default Board;